import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';

import { ModalAddToCalendarComponent } from '@app/components/lifeAct/modalAddToCalendar/modalAddToCalendar.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { PlInputModule } from '@app/components/pl-input/pl-input.module';
import { ButtonModule } from '@app/components/button/button.module';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { PlDatepickerModule } from '@app/components/pl-datepicker/pl-datepicker.module';
import { PlTimepickerModule } from '@app/components/pl-timepicker/pl-timepicker.module';
import { PlSlicePipeModule } from '@shared/pipes/plSlice/plSlice.pipe.module';

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    FormsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    PlDatepickerModule,
    PlIconModule,
    PlInputModule,
    PlTimepickerModule,
    TranslateModule,
    PlSlicePipeModule,
  ],
  declarations: [ModalAddToCalendarComponent],
  exports: [ModalAddToCalendarComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalAddToCalendarModule {}
